/**
 * The internal dependencies.
 */
import createAction from 'lib/helpers/create-action';

export const paymentStatusSet = createAction('PAYMENT_STATUS@@SET');
